import { IUnit } from "../interfaces/unit";

export class WeightUnits {
  static kg: IUnit = { id: 0, display: "kg" };
  static lb: IUnit = { id: 1, display: "lb" };

  static getById(id: number) {
    let values = Object.values(WeightUnits);
    return values[id];
  }

  staticconvertLbToKg(lb: number): number {
    return lb / 2.205;
  }

  static convertKgToLb(kg: number): number {
    return kg * 2.205;
  }
}
